import PrimaryButton from "../../../Components/Buttons/primary-button";

import { useModalContext } from "../../../Contexts/ModalContext";

import { modalVariants } from "../../../Utils/constants";

import { StakeCardFrontSide } from "../../../Assets/Images";

export default function renderStakeCheckingApproved(modalContext) {
  const {
    updateModalComponent,
    pushModalStack,
    setModalVariant,
    setModalPromoComponent,
    setModalTitle,
    setModalClassName,
  } = modalContext;

  updateModalComponent(StakeCheckingApproved);
  pushModalStack(() => renderStakeCheckingApproved(modalContext));
  setModalPromoComponent(null);
  setModalTitle("");
  modalContext.setModalAriaLabel?.("Stake Checking application approved");
  setModalClassName("hide-header no-full-screen");
  setModalVariant(modalVariants.flexDialog);
}

const StakeCheckingApproved = () => {
  const { popModalStack } = useModalContext();

  return (
    <>
      <div className="modal-dialog-content mt-6">
        <img className="stake-card-front-side" src={StakeCardFrontSide} alt="" />
        <h3 className="modal-status-title mt-6 mb-5">Congratulations! You've been approved</h3>
        <div className="numbered-list">
          <div className="list-item">
            <span className="list-item-badge">✅</span>
            <div className="list-item-content">
              <p className="text-lg-medium color--mist mb-0">
                Your Stake Checking account has been approved and is active.
              </p>
            </div>
          </div>
          <div className="list-item">
            <span className="list-item-badge">⏳</span>
            <div className="list-item-content">
              <p className="text-lg-medium color--mist mb-0">
                Debit cards are not available yet and will be issued at a later date.
              </p>
            </div>
          </div>
          <div className="list-item">
            <span className="list-item-badge">🔔</span>
            <div className="list-item-content">
              <p className="text-lg-medium color--mist mb-0">
                We’ll notify you as soon as your Stake Debit card is ready.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="action-container">
        <PrimaryButton onClick={() => popModalStack(1)}>Done</PrimaryButton>
      </div>
    </>
  );
};
